import { Check, X } from "lucide-react";
import styles from "./PlayerItem.module.css";
import type {HeatRegistration} from '@iziping/common';
import {formatPlayersSimple} from '@iziping/common';
import React from "react";

interface Props {
    player: HeatRegistration;
    index: number;
    qualifiedCount: number;
}

const PlayerItem: React.FC<Props> = ({ player, index, qualifiedCount }) => {

    const qualified = index < qualifiedCount;

    return (
        <div className={styles.row}>
          <div className={styles.index}>{index + 1}</div>
          <span className={styles.playerInfo}>
            {formatPlayersSimple(player)}
          </span>
            {qualified ? <Check size={18} color="#22c55e"/> : <X size={18} color="#ef4444"
            />
            }
        </div>
    );
};

export default PlayerItem;